var _metadata, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAileronLightWebfont(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null)), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("font", {
    id: "aileronlight",
    horizAdvX: 1148
  }, /*#__PURE__*/React.createElement("fontFace", {
    unitsPerEm: 2048,
    ascent: 1577,
    descent: -471
  }), /*#__PURE__*/React.createElement("missingGlyph", {
    horizAdvX: 417
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\uFB01",
    horizAdvX: 972,
    d: "M47 973v102h117v51q0 84 4 123q15 140 118.5 217.5t291.5 77.5q50 0 112 -10v-107q-368 37 -395 -184q-4 -35 -4 -106v-62h526v-1075h-127v973h-399v-973h-127v973h-117z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\uFB02",
    horizAdvX: 942,
    d: "M47 973v102h96v51q0 84 4 123q15 140 107 217.5t254 77.5q159 0 254 -39v-1218q0 -84 2 -117q3 -52 30.5 -69t96.5 -9v-94q-33 -6 -100 -6q-71 0 -110.5 31.5t-43.5 113.5q-2 37 -2 146v1144q-52 17 -131 17q-107 0 -163.5 -56t-66.5 -145q-4 -35 -4 -106v-62h222v-102 h-222v-973h-127v973h-96z"
  }), /*#__PURE__*/React.createElement("glyph", {
    horizAdvX: 0
  }), /*#__PURE__*/React.createElement("glyph", {
    horizAdvX: 682
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: " ",
    horizAdvX: 417
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\t",
    horizAdvX: 417
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA0",
    horizAdvX: 417
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "!",
    horizAdvX: 464,
    d: "M135 70q0 41 27.5 68.5t70.5 27.5q41 0 69 -27.5t28 -68.5q0 -43 -28 -71t-69 -28q-43 0 -70.5 28t-27.5 71zM156 1413h153l-18 -1098h-117z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\"",
    horizAdvX: 548,
    d: "M127 1505h131l-14 -508h-103zM360 1505h134l-17 -508h-100z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "#",
    d: "M131 469v88h221l64 299h-223v88h241l101 469h90l-101 -469h201l100 469h93l-101 -469h201v-88h-219l-64 -299h221v-88h-239l-101 -469h-92l101 469h-201l-100 -469h-91l101 469h-203zM442 557h201l64 299h-201z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "$",
    d: "M109 377h133q17 -130 96 -208.5t207 -92.5v579q-88 24 -153.5 55.5t-119 78.5t-81 114t-27.5 154q0 164 106.5 265.5t274.5 117.5v157h90v-157q119 -7 206 -62.5t132.5 -139.5t58.5 -191h-135q-14 129 -80 204.5t-182 85.5v-557q212 -66 308.5 -168.5t96.5 -261.5 q0 -158 -111.5 -260.5t-293.5 -116.5v-157h-90v157q-187 9 -305.5 115.5t-130.5 288.5zM299 1073q0 -115 61 -177.5t185 -100.5v542q-111 -14 -178.5 -82t-67.5 -182zM635 76q125 9 196.5 77t71.5 183q0 110 -64 184t-204 119v-563z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "%",
    horizAdvX: 1484,
    d: "M106 1112q0 147 79 236.5t210 89.5t209 -89.5t78 -236.5q0 -146 -78 -236t-209 -90t-210 90t-79 236zM219 0l916 1413h133l-918 -1413h-131zM233 1112q0 -107 43.5 -170t118.5 -63t118.5 63t43.5 170q0 108 -43.5 169.5t-118.5 61.5t-118.5 -61.5t-43.5 -169.5zM801 297 q0 147 79 236.5t210 89.5t208.5 -89.5t77.5 -236.5q0 -146 -77.5 -236t-208.5 -90t-210 90t-79 236zM928 297q0 -108 43.5 -171t118.5 -63t118 63t43 171q0 109 -43 171t-118 62t-118.5 -62t-43.5 -171z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "&",
    horizAdvX: 1329,
    d: "M135 342q0 142 95 243.5t253 129.5q-128 26 -205 110t-77 219q0 175 135 286.5t350 111.5q129 0 246 -21v-104q-115 22 -252 22q-153 0 -245.5 -77.5t-92.5 -210.5q0 -79 25 -135.5t71 -86.5t96.5 -44t114.5 -17q39 -2 127 -2h160v260h127v-260h209v-107h-209v-649 q-183 -39 -375 -39q-130 0 -226.5 17.5t-172.5 58.5t-115 115t-39 180zM276 360q0 -156 102 -221t314 -65q130 0 244 20v565h-160q-84 0 -125 -4q-180 -15 -277.5 -90t-97.5 -205z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "'",
    horizAdvX: 284,
    d: "M72 1505h131l-15 -508h-102z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "(",
    horizAdvX: 628,
    d: "M221 717q0 242 65.5 476t178.5 404h92q-114 -188 -176 -416t-62 -464t62 -464.5t176 -416.5h-92q-113 170 -178.5 404.5t-65.5 476.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ")",
    horizAdvX: 628,
    d: "M66 -164q113 188 174 416.5t61 464.5t-61 464t-174 416h90q113 -169 178 -403.5t65 -476.5t-65 -477t-178 -404h-90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "*",
    horizAdvX: 1124,
    d: "M178 623l29 94l321 -123l-14 379h96l-14 -379l319 123l31 -94l-325 -93l231 -290l-80 -58l-211 314l-209 -314l-80 58l232 290z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "+",
    d: "M152 604v86h376v434h93v-434h376v-86h-376v-428h-93v428h-376z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ",",
    horizAdvX: 397,
    d: "M-41 -244l135 391h137v-18l-153 -373h-119z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "-",
    horizAdvX: 561,
    d: "M66 535v88h430v-88h-430z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ".",
    horizAdvX: 397,
    d: "M78 70q0 41 27.5 68.5t70.5 27.5q41 0 68.5 -27.5t27.5 -68.5q0 -43 -27.5 -71t-68.5 -28q-43 0 -70.5 28t-27.5 71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "/",
    horizAdvX: 589,
    d: "M-10 -61l514 1536h96l-514 -1536h-96z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 0,
    d: "M80 707q0 735 495 735q108 0 192.5 -36.5t141 -101t93 -158.5t52 -202t15.5 -237t-15.5 -237t-52 -202t-93 -158.5t-141 -101.5t-192.5 -37q-109 0 -194 37t-141 101.5t-92.5 158.5t-52 201.5t-15.5 237.5zM221 707q0 -633 354 -633q353 0 353 633q0 632 -353 632 q-354 0 -354 -632z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 1,
    d: "M272 1042v138l310 192q63 41 127 41h79v-1413h-126v1280z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 2,
    d: "M109 0v76l501 504q163 163 225 259.5t62 202.5q0 128 -76 212.5t-213 84.5q-143 0 -226 -88.5t-101 -249.5l-2 -20h-127l2 20q22 210 146 325.5t323 115.5q135 0 230.5 -53.5t140 -139.5t44.5 -194q0 -134 -79 -255.5t-271 -307.5l-393 -386h743v-106h-929z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 3,
    d: "M92 418h127l2 -21q15 -154 110.5 -238.5t246.5 -84.5q150 0 245 82t95 225q0 134 -92.5 209.5t-278.5 75.5h-35v106h35q140 0 241 80.5t101 218.5q0 125 -79.5 196.5t-205.5 71.5q-133 0 -221.5 -80t-101.5 -227l-2 -20h-127l2 20q19 192 142.5 301t321.5 109 q191 0 301.5 -99t110.5 -258q0 -123 -74 -216t-194 -126q141 -33 219 -123t78 -233q0 -126 -68 -222t-179 -145t-245 -49q-202 0 -326 105.5t-147 320.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 4,
    d: "M59 377v67l719 969h123v-932h189v-104h-189v-377h-127v377h-715zM221 481h553v762q-102 -154 -141 -209z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 5,
    d: "M111 391h127l4 -20q23 -138 105 -217.5t222 -79.5q149 0 247.5 96.5t98.5 269.5q0 170 -89 270.5t-240 100.5q-112 0 -193 -51t-135 -164h-121l111 815h770v-106h-668l-82 -562l84 97q110 73 252 73q216 0 334.5 -129.5t118.5 -334.5q0 -146 -69 -257t-178.5 -166 t-240.5 -55q-193 0 -314 101t-142 299z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 6,
    d: "M88 629q0 210 40 368.5t112.5 254.5t166.5 143t209 47q180 0 290 -100t134 -273l2 -20h-135l-4 20q-55 270 -297 270q-365 0 -383 -643l66 117q123 135 309 135q144 0 250 -64t159.5 -172.5t53.5 -246.5q0 -215 -138 -354.5t-352 -139.5q-483 0 -483 658zM238 469 q0 -170 91 -282.5t244 -112.5t250 107.5t97 271.5q0 172 -89.5 282.5t-252.5 110.5q-144 0 -242 -102.5t-98 -274.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 7,
    d: "M98 1307v106h973v-59l-721 -1354h-137l698 1307h-813z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 8,
    d: "M86 381q0 129 81.5 225.5t211.5 134.5q-103 36 -165 122t-62 204q0 168 118 271.5t318 103.5q204 0 321 -103t117 -272q0 -118 -67.5 -204.5t-176.5 -121.5q126 -34 203.5 -131t77.5 -229q0 -104 -41 -185t-110.5 -129.5t-155 -73t-181.5 -24.5q-103 0 -190 24.5 t-154.5 73.5t-106 129.5t-38.5 184.5zM227 377q0 -142 97.5 -223.5t255.5 -81.5q152 0 247 81.5t95 223.5q0 134 -86 219.5t-256 85.5q-171 0 -262 -86t-91 -219zM289 1063q0 -129 82.5 -204t216.5 -75t217.5 75t83.5 204q0 122 -79.5 199t-221.5 77q-141 0 -220 -77 t-79 -199z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 9,
    d: "M90 948q0 215 138 354.5t350 139.5q483 0 483 -658q0 -207 -40 -365.5t-112 -255t-166 -144.5t-208 -48q-180 0 -290 100t-134 273l-5 21h136l4 -21q56 -270 297 -270q64 0 117.5 20t102 66.5t83 119.5t56.5 183.5t26 253.5l-68 -117q-120 -135 -309 -135 q-214 0 -337.5 135.5t-123.5 347.5zM231 963q0 -174 89 -285t253 -111q143 0 241.5 103.5t98.5 275.5q0 169 -91 281t-244 112q-154 0 -250.5 -106t-96.5 -270z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ":",
    horizAdvX: 397,
    d: "M78 70q0 41 27.5 68.5t70.5 27.5q41 0 68.5 -27.5t27.5 -68.5q0 -43 -27.5 -71t-68.5 -28q-43 0 -70.5 28t-27.5 71zM78 1014q0 42 28 70t70 28q41 0 68.5 -28.5t27.5 -69.5t-27.5 -68.5t-68.5 -27.5q-43 0 -70.5 27.5t-27.5 68.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ";",
    horizAdvX: 397,
    d: "M-41 -244l135 404h137l2 -21l-155 -383h-119zM78 1014q0 42 28 70t70 28q41 0 68.5 -28.5t27.5 -69.5t-27.5 -68.5t-68.5 -27.5q-43 0 -70.5 27.5t-27.5 68.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "<",
    d: "M186 492v102l822 407v-106l-723 -350l723 -352v-109z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "=",
    d: "M145 406v88h861v-88h-861zM145 801v88h861v-88h-861z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ">",
    d: "M131 84v106l723 353l-723 350v108l821 -407v-102z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "?",
    horizAdvX: 1040,
    d: "M84 1012q6 194 129 312t319 118q193 0 302.5 -105t109.5 -266q0 -200 -205 -405q-108 -105 -143.5 -175t-38.5 -176h-127q8 122 44.5 199.5t143.5 192.5q103 112 144 191t41 173q0 123 -74.5 195.5t-200.5 72.5q-138 0 -220.5 -86t-92.5 -241h-131zM397 70q0 41 28 68.5 t69 27.5q43 0 70.5 -27.5t27.5 -68.5q0 -43 -27.5 -71t-70.5 -28q-41 0 -69 28t-28 71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "@",
    horizAdvX: 1744,
    d: "M117 498q0 157 48 296.5t130.5 241.5t190 176t229.5 111t246 37q194 0 345 -85t234.5 -239t83.5 -352q0 -131 -35 -235.5t-93.5 -167t-129 -95t-145.5 -32.5q-86 0 -143.5 39.5t-65.5 125.5l-39 -79q-97 -103 -221 -103q-39 0 -76 9.5t-74 33t-64 59t-44 92t-17 128.5 q0 138 56 259t158.5 196t226.5 75q114 0 169 -65l27 -105l35 133h123l-119 -497q-16 -73 -16 -109q0 -102 110 -102q114 0 196.5 116t82.5 318q0 186 -76.5 322t-205 203t-292.5 67q-105 0 -210.5 -32.5t-200.5 -98t-168 -156t-116.5 -215.5t-43.5 -266q0 -151 48.5 -271.5 t132 -197t191.5 -116.5t230 -40q295 0 531 170l40 -78q-272 -182 -575 -182q-108 0 -208.5 27.5t-189 85.5t-154.5 140.5t-104 200t-38 257.5zM616 471q0 -119 45 -176t121 -57q88 0 160.5 81t104.5 218l18 79q30 131 -12 202t-131 71q-86 0 -157 -59t-110 -154.5 t-39 -204.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "A",
    horizAdvX: 1290,
    d: "M66 0l522 1413h170l510 -1413h-138l-184 518h-563l-182 -518h-135zM420 625h489l-239 686z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "B",
    horizAdvX: 1253,
    d: "M203 0v1413h393q104 0 174 -6q167 -19 259.5 -106t92.5 -234q0 -125 -66 -204.5t-186 -112.5q304 -66 304 -349q0 -89 -31 -161.5t-84 -119.5t-119 -75t-141 -37q-63 -8 -166 -8h-430zM330 106h332q56 0 96 3q121 10 200.5 81t79.5 199t-69.5 202.5t-208.5 86.5 q-71 6 -111 6h-319v-578zM330 788h297q37 0 112 7q114 13 180 77t66 181q0 121 -72 181.5t-188 70.5q-41 2 -121 2h-274v-519z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "C",
    horizAdvX: 1415,
    d: "M100 700q0 215 83.5 384t233.5 263.5t341 94.5q245 0 387.5 -129t171.5 -340l2 -21h-127l-4 21q-34 169 -144 267.5t-292 98.5q-222 0 -366 -174t-144 -458q0 -290 138 -461.5t357 -171.5q188 0 299.5 101.5t145.5 273.5l4 20h127l-2 -20q-14 -100 -56.5 -185 t-112.5 -151.5t-176 -104t-237 -37.5q-190 0 -333.5 92.5t-219.5 257.5t-76 379z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "D",
    horizAdvX: 1429,
    d: "M203 0v1413h420q107 0 170 -6q112 -13 209 -59t177 -127t126.5 -210t46.5 -292q0 -161 -47.5 -293t-127 -217.5t-176.5 -136t-204 -64.5q-72 -8 -181 -8h-413zM330 106h280q112 0 174 9q89 13 165.5 58t135.5 119t93 183.5t34 243.5q0 132 -34.5 238.5t-94.5 176.5 t-136.5 111.5t-166.5 54.5q-52 7 -164 7h-286v-1201z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "E",
    horizAdvX: 1179,
    d: "M203 0v1413h895v-104h-768v-549h714v-107h-714v-549h788v-104h-915z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "F",
    horizAdvX: 1134,
    d: "M203 0v1413h895v-104h-768v-549h694v-107h-694v-653h-127z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "G",
    horizAdvX: 1441,
    d: "M100 700q0 215 84 384t235.5 263.5t344.5 94.5q124 0 225 -35.5t169 -99t110 -148t57 -186.5l2 -21h-127l-4 21q-34 169 -144 267.5t-292 98.5q-226 0 -372 -173.5t-146 -458.5q0 -290 138.5 -461.5t358.5 -171.5q86 0 165.5 31.5t143 90t102 152.5t38.5 209h-385v105 h512v-662h-115v291l-55 -127q-69 -96 -176 -144.5t-238 -48.5q-191 0 -335 92.5t-220 257.5t-76 379z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "H",
    horizAdvX: 1437,
    d: "M203 0v1413h127v-665h827v665h127v-1413h-127v639h-827v-639h-127z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "I",
    horizAdvX: 483,
    d: "M203 0v1413h127v-1413h-127z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "J",
    horizAdvX: 1077,
    d: "M106 473h127l5 -76q7 -165 84.5 -244t214.5 -79q131 0 203.5 78t84.5 219q2 43 2 164v878h127v-874q0 -109 -4 -177q-5 -84 -33.5 -153.5t-79.5 -123.5t-132 -84t-185 -30q-189 0 -297 111t-114 315z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "K",
    horizAdvX: 1204,
    d: "M203 0v1413h127v-749l737 749h152l-674 -688l647 -725h-180l-563 641l-119 -125v-516h-127z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "L",
    horizAdvX: 1150,
    d: "M203 0v1413h127v-1309h788v-104h-915z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "M",
    horizAdvX: 1718,
    d: "M203 0v1413h207l477 -1307l475 1307h203v-1413h-127v762q0 374 4 538q-79 -235 -193 -536l-286 -764h-160l-289 766q-131 357 -188 532q4 -164 4 -536v-762h-127z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "N",
    horizAdvX: 1409,
    d: "M203 0v1413h192l738 -1290q-7 308 -7 561v729h125l2 -1413h-194l-735 1290q6 -261 6 -561v-729h-127z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "O",
    horizAdvX: 1490,
    d: "M100 707q0 215 77 380.5t227 260t352 94.5q203 0 353 -94.5t227 -259.5t77 -381q0 -214 -77 -379.5t-227 -261t-353 -95.5q-202 0 -352 95.5t-227 261t-77 379.5zM242 707q0 -292 142 -462.5t372 -170.5q232 0 374 170t142 463q0 294 -142 463t-374 169 q-231 0 -372.5 -169.5t-141.5 -462.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "P",
    horizAdvX: 1165,
    d: "M203 0v1413h391q127 0 190 -8q167 -23 263 -122t96 -273t-100.5 -278.5t-258.5 -125.5q-63 -8 -190 -8h-264v-598h-127zM330 707h274q111 0 170 10q104 16 168 88.5t64 204.5q0 128 -64 198t-168 86q-65 11 -170 11h-274v-598z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "Q",
    horizAdvX: 1486,
    d: "M100 707q0 215 77 380.5t227 260t352 94.5q203 0 353 -94.5t227 -259.5t77 -381q0 -188 -70.5 -342.5t-216.5 -251.5q136 -13 275 -131l-74 -88q-91 64 -152 87t-128 23q-61 0 -146 -18q-67 -15 -145 -15q-202 0 -352 95.5t-227 261t-77 379.5zM242 707 q0 -292 142 -462.5t372 -170.5q232 0 374 170t142 463q0 294 -142 463t-374 169q-231 0 -372.5 -169.5t-141.5 -462.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "R",
    horizAdvX: 1230,
    d: "M203 0v1413h415q127 0 193 -8q163 -21 255.5 -112.5t92.5 -254.5q0 -133 -74.5 -219.5t-191.5 -116.5q87 -35 135 -121.5t59 -203.5q15 -146 36.5 -231.5t58.5 -145.5h-142q-55 142 -79 362q-32 264 -232 275q-37 2 -111 2h-288v-639h-127zM330 745h291q84 0 143 5 q119 9 188.5 82t69.5 196q0 234 -242 270q-73 9 -162 9h-288v-562z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "S",
    horizAdvX: 1179,
    d: "M96 389h135q26 -150 132.5 -232.5t261.5 -82.5q143 0 239.5 75t96.5 195q0 133 -84 204t-287 122q-107 28 -181 59.5t-132.5 76.5t-86.5 108.5t-28 146.5q0 168 133.5 274.5t325.5 106.5q203 0 319 -113t137 -295h-133q-19 145 -106.5 225t-227.5 80q-130 0 -220.5 -66 t-90.5 -186q0 -124 76 -186t266 -110q235 -61 345 -158.5t110 -267.5q0 -173 -135.5 -283.5t-339.5 -110.5q-220 0 -361 109t-164 309z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "T",
    horizAdvX: 1228,
    d: "M68 1309v104h1163v-104h-518v-1309h-127v1309h-518z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "U",
    horizAdvX: 1333,
    d: "M190 506v907h127v-901q0 -76 5 -125q13 -141 106 -227t264 -86q170 0 263 86t106 227q6 59 6 125v901h127v-907q0 -58 -6 -131q-13 -181 -138.5 -292.5t-357.5 -111.5t-357.5 111t-139.5 293q-5 61 -5 131z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "V",
    horizAdvX: 1243,
    d: "M61 1413h138l460 -1315l469 1315h138l-525 -1413h-170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "W",
    horizAdvX: 1851,
    d: "M53 1413h144l313 -1298l356 1278h170l342 -1278l332 1298h133l-387 -1413h-166l-342 1266l-360 -1266h-168z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "X",
    horizAdvX: 1239,
    d: "M53 0l506 711l-469 702h143l406 -614l428 614h150l-506 -698l514 -715h-152l-440 627l-430 -627h-150z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "Y",
    horizAdvX: 1163,
    d: "M43 1413h145l424 -725l414 725h145l-501 -848v-565h-127v563z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "Z",
    horizAdvX: 1169,
    d: "M86 0v98l877 1209h-820v106h967v-104l-872 -1203h884v-106h-1036z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "[",
    horizAdvX: 632,
    d: "M227 -164v1761h326v-88h-236v-1585h236v-88h-326z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\\\\\\\",
    horizAdvX: 589,
    d: "M-10 1475h96l514 -1536h-96z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "]",
    horizAdvX: 616,
    d: "M63 -76h236v1585h-236v88h326v-1761h-326v88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "^",
    d: "M166 440l356 822h109l356 -822h-106l-303 734l-304 -734h-108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "_",
    horizAdvX: 1024,
    d: "M102 -84h820v-88h-820v88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "`",
    horizAdvX: 614,
    d: "M109 1413h124l125 -225h-88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "a",
    horizAdvX: 1058,
    d: "M82 272q0 183 164 276t463 93h69v39q0 90 -4 133q-16 197 -242 197q-116 0 -188 -62.5t-84 -185.5h-133q10 159 121.5 254.5t283.5 95.5q343 0 369 -287q4 -47 4 -143v-379q0 -109 21 -303h-127l-19 197l-53 -115q-111 -111 -301 -111q-155 0 -249.5 78.5t-94.5 222.5z M221 283q0 -103 62.5 -157t181.5 -54q140 0 226.5 96.5t86.5 249.5v125q-49 3 -95 3q-63 0 -121 -6q-99 -11 -176.5 -41t-121 -85t-43.5 -131z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "b",
    horizAdvX: 1200,
    d: "M150 0v1505h126v-622l72 118q114 111 307 111q223 0 353.5 -155.5t130.5 -401.5q0 -143 -42 -256.5t-114 -184t-163.5 -107t-196.5 -36.5q-81 0 -155 25t-124 72l-68 116v-184h-126zM276 485q0 -111 31 -194t83 -129t110.5 -68t122.5 -22q166 0 271 125.5t105 341.5 q0 133 -40 238t-123.5 169t-198.5 64q-76 0 -138.5 -24t-114 -74t-80 -138t-28.5 -207v-82z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "c",
    horizAdvX: 1075,
    d: "M61 541q0 131 40.5 240t109.5 180.5t160.5 111t193.5 39.5q185 0 304.5 -104.5t144.5 -278.5h-133q-28 138 -109 210.5t-211 72.5q-70 0 -133.5 -28.5t-114.5 -83.5t-81.5 -145.5t-30.5 -203.5q0 -121 29 -215t78.5 -150.5t111 -85t131.5 -28.5q122 0 207 69t114 197h132 q-36 -177 -159.5 -272t-301.5 -95q-103 0 -189.5 36t-152.5 105t-103 179t-37 250z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "d",
    horizAdvX: 1204,
    d: "M61 528q0 143 42 256.5t114 184t164 107t197 36.5q177 0 278 -98l68 -117v608h127v-1505h-127v201l-72 -119q-111 -111 -307 -111q-223 0 -353.5 155.5t-130.5 401.5zM201 545q0 -133 40 -238.5t123.5 -170t198.5 -64.5q76 0 138.5 24t114 74.5t80 138.5t28.5 207v82 q0 110 -31 193t-82.5 129t-110 68t-122.5 22q-167 0 -272 -125t-105 -340z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "e",
    horizAdvX: 1103,
    d: "M61 541q0 170 66 301t180 200.5t256 69.5q147 0 253 -73.5t157 -194.5t51 -273q0 -34 -4 -67h-821q5 -115 35.5 -201t80 -135t108.5 -72.5t128 -23.5q118 0 208 70.5t118 199.5h133q-37 -181 -166 -276t-301 -95q-103 0 -189.5 36t-152.5 105.5t-103 179.5t-37 249z M199 604h696q-10 201 -101.5 303.5t-234.5 102.5q-142 0 -244.5 -106.5t-115.5 -299.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "f",
    horizAdvX: 548,
    d: "M47 973v102h117v121q0 82 4 121q12 110 79.5 168.5t170.5 58.5q52 0 114 -10v-107q-42 8 -78 8q-52 0 -88 -18q-62 -31 -71 -104q-4 -35 -4 -107v-131h221v-102h-221v-973h-127v973h-117z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "g",
    horizAdvX: 1204,
    d: "M61 528q0 143 42 256.5t114 184t164 107t197 36.5q177 0 278 -98l68 -117v188h127v-811q0 -191 -2 -254q-7 -217 -136 -337.5t-352 -120.5q-419 0 -459 346l-2 24h127l4 -24q13 -118 102 -182t228 -64q169 0 262 94t99 258q2 59 2 160v27l-72 -119q-111 -111 -307 -111 q-223 0 -353.5 155.5t-130.5 401.5zM201 545q0 -133 40 -238.5t123.5 -170t198.5 -64.5q76 0 138.5 24t114 74.5t80 138.5t28.5 207v82q0 110 -31 193t-82.5 129t-110 68t-122.5 22q-167 0 -272 -125t-105 -340z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "h",
    horizAdvX: 1165,
    d: "M150 0v1516h126v-642l58 117q121 121 305 121q169 0 267.5 -86t113.5 -238q4 -55 4 -182v-606h-127v592q0 109 -4 164q-11 117 -80 185q-68 67 -195 67h-4q-70 -1 -129 -27.5t-107 -80.5t-75 -146t-27 -215v-539h-126z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "i",
    horizAdvX: 430,
    d: "M127 1317q0 36 25 61t61 25q37 0 61.5 -24.5t24.5 -61.5q0 -36 -25 -61t-61 -25q-35 0 -60.5 25.5t-25.5 60.5zM150 0v1083h126v-1083h-126z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "j",
    horizAdvX: 417,
    d: "M-41 -319q27 -3 50 -3q49 0 78 16q42 24 48 91q2 29 2 86v1212h127v-1198q0 -86 -4 -123q-18 -192 -221 -192q-53 0 -80 6v105zM115 1317q0 36 25 61t61 25q37 0 61.5 -24.5t24.5 -61.5q0 -36 -25 -61t-61 -25q-35 0 -60.5 25.5t-25.5 60.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "k",
    horizAdvX: 1019,
    d: "M150 0v1505h126v-985l555 563h166l-530 -518l534 -565h-176l-450 485l-99 -104v-381h-126z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "l",
    horizAdvX: 448,
    d: "M141 283v1222h127v-1218q0 -84 2 -117q2 -52 30 -69q19 -12 57 -12q18 0 40 3v-94q-33 -6 -100 -6q-70 0 -110 31.5t-44 113.5q-2 37 -2 146z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "m",
    horizAdvX: 1716,
    d: "M150 0v1083h126v-186l62 121q90 94 250 94q126 0 206 -61.5t109 -169.5l84 137q87 94 250 94q142 0 225.5 -78.5t102.5 -212.5q10 -69 10 -182v-639h-127v582q0 125 -8 198q-14 110 -75 170t-167 60q-124 0 -198 -107t-74 -336v-567h-127v582q0 125 -8 198 q-14 110 -75 170t-167 60q-124 0 -198.5 -107t-74.5 -336v-567h-126z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "n",
    horizAdvX: 1165,
    d: "M150 0v1083h126v-209l58 117q121 121 305 121q169 0 267.5 -86t113.5 -238q4 -55 4 -182v-606h-127v592q0 109 -4 164q-11 117 -79.5 184.5t-199.5 67.5q-147 0 -242.5 -115.5t-95.5 -353.5v-539h-126z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "o",
    horizAdvX: 1175,
    d: "M61 541q0 162 59 289.5t180 204.5t288 77t288 -77t179.5 -204.5t58.5 -289.5q0 -120 -34.5 -223t-99 -180.5t-165.5 -122t-227 -44.5q-167 0 -288 77t-180 204.5t-59 288.5zM201 541q0 -217 107.5 -343t279.5 -126t279.5 126t107.5 343t-107.5 343t-279.5 126 t-279.5 -126t-107.5 -343z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "p",
    horizAdvX: 1200,
    d: "M150 -401v1491h126v-207l72 118q114 111 307 111q223 0 353.5 -155.5t130.5 -401.5q0 -143 -42 -256.5t-114 -184t-163.5 -107t-196.5 -36.5q-81 0 -155 25t-124 72l-68 116v-585h-126zM276 485q0 -111 31 -194t83 -129t110.5 -68t122.5 -22q166 0 271 125.5t105 341.5 q0 133 -40 238t-123.5 169t-198.5 64q-76 0 -138.5 -24t-114 -74t-80 -138t-28.5 -207v-82z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "q",
    horizAdvX: 1206,
    d: "M61 528q0 143 42 256.5t114 184t164 107t197 36.5q177 0 278 -98l68 -117v193h127v-1491h-127v602l-72 -119q-111 -111 -307 -111q-223 0 -353.5 155.5t-130.5 401.5zM201 545q0 -133 40 -238.5t123.5 -170t198.5 -64.5q76 0 138.5 24t114 74.5t80 138.5t28.5 207v82 q0 110 -31 193t-82.5 129t-110 68t-122.5 22q-167 0 -272 -125t-105 -340z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "r",
    horizAdvX: 620,
    d: "M150 0v1083h126v-196l78 139q79 82 187 82q39 0 63 -8v-101q-15 1 -30 1q-128 0 -208 -87q-90 -97 -90 -305v-608h-126z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "s",
    horizAdvX: 921,
    d: "M51 319h131q42 -247 293 -247q108 0 179 49t71 139t-65 142t-224 90q-77 20 -133 43.5t-105.5 59.5t-75.5 88.5t-26 119.5q0 139 100 224t261 85q170 0 268.5 -91t118.5 -241h-133q-48 230 -265 230q-99 0 -159 -52t-60 -141q0 -46 17.5 -80.5t54 -59t80 -41t106.5 -32.5 q193 -47 281 -124t88 -210q0 -141 -107.5 -220t-279.5 -79q-111 0 -197 35t-145 114.5t-74 198.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "t",
    horizAdvX: 581,
    d: "M47 977v98h139v240h127v-240h207v-98h-207v-680q0 -67 2 -96q7 -78 49 -102q28 -16 82 -16q30 0 68 5v-94q-54 -10 -131 -10q-91 0 -139.5 41.5t-55.5 130.5q-2 37 -2 139v682h-139z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "u",
    horizAdvX: 1161,
    d: "M133 451v632h127v-604q0 -89 8 -162q12 -111 84.5 -177t194.5 -66q70 0 128.5 26.5t105.5 81t73.5 147.5t26.5 216v538h127v-1083h-127v209l-60 -121q-120 -117 -303 -117q-161 0 -259.5 81.5t-117.5 215.5q-8 73 -8 183z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "v",
    horizAdvX: 1017,
    d: "M12 1083h140l360 -989l356 989h136l-418 -1083h-158z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "w",
    horizAdvX: 1554,
    d: "M12 1083h146l278 -966l264 964h162l266 -954l277 956h135l-342 -1083h-154l-266 954l-266 -954h-156z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "x",
    horizAdvX: 937,
    d: "M-6 0l387 547l-371 536h150l299 -452l303 452h147l-381 -534l383 -549h-149l-309 465l-312 -465h-147z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "y",
    horizAdvX: 1007,
    d: "M12 1083h144l350 -989l348 989h139l-434 -1140q-81 -209 -165.5 -291t-203.5 -82q-59 0 -84 6v105q34 -5 70 -5q77 0 134.5 50.5t107.5 175.5l22 57z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "z",
    horizAdvX: 931,
    d: "M35 0v98l684 871h-635v102h786v-104l-682 -865h691v-102h-844z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "{",
    horizAdvX: 614,
    d: "M141 672v90q168 16 168 170q0 67 -22 225q-23 175 -23 219q0 121 69 171t204 50h26v-88h-28q-93 0 -137 -31.5t-44 -99.5q0 -17 1.5 -35.5t3.5 -34t7.5 -55.5t10.5 -75q24 -185 24 -250q0 -85 -46.5 -142t-135.5 -67q88 -10 135 -69t47 -144q0 -62 -24 -250 q-4 -34 -10 -74.5t-8 -56t-3.5 -34.5t-1.5 -36q0 -68 44 -99.5t137 -31.5h28v-88h-26q-135 0 -204 50t-69 171q0 44 23 219q22 158 22 226q0 154 -168 170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "|",
    horizAdvX: 512,
    d: "M211 -410v2048h90v-2048h-90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "}",
    horizAdvX: 614,
    d: "M51 -76h29q94 0 137 31t43 100q0 47 -20 201q-27 190 -27 250q0 85 47 142t135 67q-88 10 -135 69t-47 144q0 62 27 250q20 154 20 200q0 69 -43 100t-137 31h-29v88h27q135 0 204.5 -50t69.5 -171q0 -55 -24 -219q-21 -151 -21 -225q0 -154 166 -170v-90 q-166 -16 -166 -170q0 -75 21 -226q24 -164 24 -219q0 -121 -69.5 -171t-204.5 -50h-27v88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "~",
    d: "M141 461q0 260 207 260q57 0 104 -17.5t144 -70.5q83 -45 126.5 -62.5t84.5 -17.5q61 0 87 43t26 129h88q0 -260 -207 -260q-57 0 -104 17.5t-144 70.5q-80 44 -125 62t-86 18q-61 0 -87 -43t-26 -129h-88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA1",
    horizAdvX: 464,
    d: "M135 1018q0 41 27.5 68.5t70.5 27.5q41 0 69 -27.5t28 -68.5q0 -42 -28 -70t-69 -28q-43 0 -70.5 27.5t-27.5 70.5zM156 -328l18 1098h117l18 -1098h-153z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA2",
    horizAdvX: 1124,
    d: "M96 541q0 240 126 392.5t317 176.5v160h90v-156q173 -7 285 -110t135 -271h-134q-26 127 -98.5 198.5t-187.5 80.5v-938q105 12 178.5 80t97.5 184h133q-33 -163 -141 -257t-268 -108v-157h-90v157q-197 13 -320 159.5t-123 408.5zM236 553q0 -217 85.5 -337.5 t217.5 -139.5v934q-130 -24 -216.5 -141t-86.5 -316z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA3",
    d: "M129 0v94q122 32 191 118t69 202q0 67 -17.5 126.5t-56.5 135.5h-168v88h123q-75 150 -75 276q0 178 119 290t296 112q193 0 297 -110t117 -292h-135q-30 299 -283 299q-122 0 -196 -80t-74 -196q0 -79 19 -142t67 -157h457v-88h-416q61 -128 61 -244 q0 -108 -47.5 -186.5t-146.5 -139.5h698v-106h-899z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA4",
    d: "M166 270l119 119q-76 99 -76 227t76 230l-119 121l63 63l121 -121q98 76 225 76q125 0 224 -76l123 121l63 -63l-121 -123q76 -99 76 -228q0 -125 -76 -227l121 -121l-63 -63l-121 119q-99 -76 -226 -76q-126 0 -225 76l-121 -119zM307 616q0 -120 75.5 -199t192.5 -79 q115 0 191 79t76 199t-76 199.5t-191 79.5q-117 0 -192.5 -79.5t-75.5 -199.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA5",
    d: "M45 1413h160l375 -688l372 688h150l-404 -694h289v-86h-338l-10 -19v-125h348v-88h-348v-401h-127v401h-350v88h350v121l-12 23h-338v86h287z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA6",
    horizAdvX: 512,
    d: "M211 -328v697h90v-697h-90zM211 717v696h90v-696h-90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA7",
    horizAdvX: 1124,
    d: "M80 590q0 118 63 195.5t170 113.5q-112 91 -112 231q0 144 98.5 228t255.5 84q171 0 269.5 -89t119.5 -243h-133q-51 231 -256 231q-95 0 -157 -52t-62 -144q0 -99 78 -160.5t225 -97.5q213 -53 318.5 -141.5t105.5 -231.5q0 -106 -63.5 -186.5t-165.5 -118.5 q116 -91 116 -254q0 -146 -112.5 -228.5t-278.5 -82.5q-173 0 -282.5 86t-137.5 264h133q61 -250 295 -250q107 0 176.5 53.5t69.5 147.5q0 104 -73 168t-267 108q-82 20 -150.5 51.5t-124 76t-87 106.5t-31.5 135zM217 598q0 -94 84.5 -162.5t220.5 -99.5q108 -22 185 -55 q97 12 159 71.5t62 147.5q0 101 -81.5 163.5t-258.5 108.5q-98 27 -156 53q-93 -8 -154 -63.5t-61 -163.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA8",
    horizAdvX: 614,
    d: "M109 1292q0 29 22 51.5t51 22.5q31 0 53.5 -22.5t22.5 -51.5q0 -31 -22.5 -53t-53.5 -22q-29 0 -51 22t-22 53zM356 1292q0 29 22.5 51.5t53.5 22.5q29 0 51.5 -22.5t22.5 -51.5q0 -30 -22 -52.5t-52 -22.5q-31 0 -53.5 22t-22.5 53z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA9",
    horizAdvX: 1716,
    d: "M90 727q0 162 60 307t162.5 249t244.5 165t301 61t302 -61t245.5 -165t162.5 -249t60 -307t-60 -307t-162.5 -249t-245.5 -165t-302 -61t-301 61t-244.5 165t-162.5 249t-60 307zM186 727q0 -143 52.5 -271.5t142 -220t214 -145t263.5 -53.5t264 53.5t215 145t142.5 220 t52.5 271.5t-52.5 271.5t-142.5 220.5t-215 146t-264 54t-263.5 -54t-214 -146t-142 -220.5t-52.5 -271.5zM455 725q0 211 115 335t298 124q152 0 252.5 -84t126.5 -230h-135q-18 97 -78 153t-166 56q-129 0 -201.5 -97.5t-72.5 -252.5q0 -157 74.5 -254.5t195.5 -97.5 q98 0 163 56t83 151h135q-33 -147 -132.5 -229.5t-260.5 -82.5q-173 0 -285 125t-112 328z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xAB",
    horizAdvX: 1097,
    d: "M260 508l281 340h116l-280 -340l280 -340h-116zM569 508l281 340h117l-281 -340l281 -340h-117z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xAC",
    d: "M195 684v88h741v-342h-90v254h-651z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xAD",
    horizAdvX: 561,
    d: "M66 535v88h430v-88h-430z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xAE",
    horizAdvX: 1050,
    d: "M96 1135q0 189 120.5 309.5t309.5 120.5t309.5 -120.5t120.5 -309.5t-120.5 -309.5t-309.5 -120.5t-309.5 120.5t-120.5 309.5zM174 1135q0 -156 98.5 -255.5t253.5 -99.5q154 0 252.5 100t98.5 255q0 156 -98.5 255t-252.5 99q-155 0 -253.5 -98.5t-98.5 -255.5z M385 932v418h129q33 0 51 -2q129 -14 129 -115q0 -38 -24 -65t-62 -38q53 -14 60 -88q9 -63 30 -110h-90q-16 49 -20 98q-8 51 -62 51h-61v-149h-80zM465 1151h47q29 0 41 2q55 9 55 64q0 54 -53 65q-12 2 -37 2h-53v-133z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xAF",
    horizAdvX: 614,
    d: "M100 1249v82h414v-82h-414z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB0",
    horizAdvX: 593,
    d: "M63 1212q0 101 65.5 165.5t168.5 64.5q102 0 167.5 -64.5t65.5 -165.5q0 -102 -65.5 -165.5t-167.5 -63.5q-103 0 -168.5 63.5t-65.5 165.5zM160 1212q0 -63 38.5 -103t98.5 -40t97.5 40t37.5 103t-37.5 102.5t-97.5 39.5t-98.5 -39.5t-38.5 -102.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB1",
    d: "M141 0v88h844v-88h-844zM141 608v88h377v387h90v-387h377v-88h-377v-391h-90v391h-377z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB4",
    horizAdvX: 614,
    d: "M254 1188l125 225h123l-162 -225h-86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB6",
    horizAdvX: 1130,
    d: "M94 1034q0 153 85.5 260.5t236.5 116.5q35 2 114 2h447v-1638h-92v1550h-215v-1550h-92v880h-48q-79 0 -114 2q-151 9 -236.5 116.5t-85.5 260.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB7",
    horizAdvX: 362,
    d: "M76 625q0 44 30 74t76 30q44 0 74.5 -30t30.5 -74t-30.5 -74.5t-74.5 -30.5q-46 0 -76 30t-30 75z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB8",
    horizAdvX: 614,
    d: "M137 -338q43 -22 109 -22q65 0 102 26.5t37 75.5q0 118 -199 104l90 170h89l-60 -106q83 -9 127.5 -51t44.5 -115q0 -84 -66 -129t-169 -45q-62 0 -105 18v74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xBB",
    horizAdvX: 1097,
    d: "M133 168l281 340l-281 340h115l280 -340l-280 -340h-115zM442 168l281 340l-281 340h115l281 -340l-281 -340h-115z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xBF",
    horizAdvX: 991,
    d: "M139 10q0 205 207 406q109 107 144 175.5t38 174.5h125q-6 -121 -42 -198t-144 -191q-103 -112 -144.5 -192.5t-41.5 -174.5q0 -123 74.5 -195.5t201.5 -72.5q137 0 219.5 87t91.5 241h133q-6 -193 -129.5 -311.5t-318.5 -118.5t-304.5 104.5t-109.5 265.5zM494 1014 q0 41 27.5 68.5t68.5 27.5t69.5 -27.5t28.5 -68.5q0 -42 -28 -70.5t-70 -28.5q-41 0 -68.5 28t-27.5 71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC0",
    horizAdvX: 1290,
    d: "M66 0l522 1413h170l510 -1413h-138l-184 518h-563l-182 -518h-135zM420 625h489l-239 686zM485 1700h125l109 -193h-86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC1",
    horizAdvX: 1290,
    d: "M66 0l522 1413h170l510 -1413h-138l-184 518h-563l-182 -518h-135zM420 625h489l-239 686zM621 1507l110 193h123l-147 -193h-86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC2",
    horizAdvX: 1290,
    d: "M66 0l522 1413h170l510 -1413h-138l-184 518h-563l-182 -518h-135zM420 625h489l-239 686zM492 1507l135 193h92l137 -193h-104l-80 135l-80 -135h-100z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC3",
    horizAdvX: 1290,
    d: "M66 0l522 1413h170l510 -1413h-138l-184 518h-563l-182 -518h-135zM420 625h489l-239 686zM469 1548q0 65 24 93t70 28q41 0 123 -27q67 -22 92 -22q33 0 33 41h63q0 -65 -24 -93t-70 -28q-40 0 -123 27q-67 22 -92 22q-33 0 -33 -41h-63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC4",
    horizAdvX: 1290,
    d: "M66 0l522 1413h170l510 -1413h-138l-184 518h-563l-182 -518h-135zM420 625h489l-239 686zM481 1604q0 31 21.5 52t52.5 21t52.5 -21t21.5 -52t-21.5 -52.5t-52.5 -21.5t-52.5 21.5t-21.5 52.5zM715 1604q0 31 21 52t52 21t52.5 -21t21.5 -52t-21.5 -52.5t-52.5 -21.5 t-52 21.5t-21 52.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC5",
    horizAdvX: 1290,
    d: "M66 0l522 1413h170l510 -1413h-138l-184 518h-563l-182 -518h-135zM420 625h489l-239 686zM508 1620q0 65 46.5 106t117.5 41t118.5 -41t47.5 -106t-47.5 -107.5t-118.5 -42.5t-117.5 42t-46.5 108zM590 1620q0 -37 23 -61.5t59 -24.5t59 24.5t23 61.5q0 36 -23 60 t-59 24t-59 -24t-23 -60z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC6",
    horizAdvX: 1851,
    d: "M-53 0l844 1413h978v-104h-784l29 -549h702v-107h-698l29 -549h743v-104h-864l-27 518h-508l-305 -518h-139zM453 625h440l-37 686z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC7",
    horizAdvX: 1415,
    d: "M100 700q0 215 83.5 384t233.5 263.5t341 94.5q245 0 387.5 -129t171.5 -340l2 -21h-127l-4 21q-34 169 -144 267.5t-292 98.5q-222 0 -366 -174t-144 -458q0 -290 138 -461.5t357 -171.5q188 0 299.5 101.5t145.5 273.5l4 20h127l-2 -20q-14 -98 -55 -181t-108 -149.5 t-168.5 -105.5t-227.5 -42l-35 -61q83 -9 127.5 -51t44.5 -115q0 -84 -66.5 -129t-169.5 -45q-61 0 -104 18v74q43 -22 108 -22t102.5 26.5t37.5 75.5q0 118 -199 104l68 127q-173 15 -301.5 111t-196.5 255t-68 361z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC8",
    horizAdvX: 1179,
    d: "M203 0v1413h895v-104h-768v-549h714v-107h-714v-549h788v-104h-915zM467 1700h125l108 -193h-86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC9",
    horizAdvX: 1179,
    d: "M203 0v1413h895v-104h-768v-549h714v-107h-714v-549h788v-104h-915zM602 1507l111 193h123l-148 -193h-86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xCA",
    horizAdvX: 1179,
    d: "M203 0v1413h895v-104h-768v-549h714v-107h-714v-549h788v-104h-915zM473 1507l135 193h92l138 -193h-105l-80 135l-80 -135h-100z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xCB",
    horizAdvX: 1179,
    d: "M203 0v1413h895v-104h-768v-549h714v-107h-714v-549h788v-104h-915zM463 1604q0 31 21.5 52t52.5 21t52 -21t21 -52t-21 -52.5t-52 -21.5t-52.5 21.5t-21.5 52.5zM696 1604q0 31 21.5 52t52.5 21t52.5 -21t21.5 -52t-21.5 -52.5t-52.5 -21.5t-52.5 21.5t-21.5 52.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xCC",
    horizAdvX: 483,
    d: "M78 1700h125l108 -193h-86zM203 0v1413h127v-1413h-127z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xCD",
    horizAdvX: 483,
    d: "M203 0v1413h127v-1413h-127zM213 1507l111 193h122l-147 -193h-86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xCE",
    horizAdvX: 483,
    d: "M84 1507l135 193h92l138 -193h-105l-80 135l-80 -135h-100zM203 0v1413h127v-1413h-127z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xCF",
    horizAdvX: 483,
    d: "M74 1604q0 31 21 52t52 21t52.5 -21t21.5 -52t-21.5 -52.5t-52.5 -21.5t-52 21.5t-21 52.5zM203 0v1413h127v-1413h-127zM307 1604q0 31 21.5 52t52.5 21t52.5 -21t21.5 -52t-21.5 -52.5t-52.5 -21.5t-52.5 21.5t-21.5 52.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD0",
    horizAdvX: 1423,
    d: "M74 639v88h123v686h421q105 0 168 -6q89 -10 169 -40.5t152 -86.5t124.5 -133t83.5 -187t31 -241q0 -161 -47.5 -293t-127 -217.5t-176 -136t-202.5 -64.5q-72 -8 -181 -8h-415v639h-123zM324 106h280q114 0 174 9q89 13 165.5 58t135.5 119t93 183.5t34 243.5 q0 132 -34.5 238.5t-94.5 176.5t-136.5 111.5t-166.5 54.5q-52 7 -162 7h-288v-580h315v-88h-315v-533z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD1",
    horizAdvX: 1409,
    d: "M203 0v1413h192l738 -1290q-7 308 -7 561v729h125l2 -1413h-194l-735 1290q6 -261 6 -561v-729h-127zM524 1548q0 65 24 93t70 28q40 0 123 -27q67 -22 93 -22q32 0 32 41h64q0 -65 -24 -93t-70 -28q-40 0 -123 27q-67 22 -92 22q-33 0 -33 -41h-64z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD2",
    horizAdvX: 1490,
    d: "M100 707q0 215 77 380.5t227 260t352 94.5q203 0 353 -94.5t227 -259.5t77 -381q0 -214 -77 -379.5t-227 -261t-353 -95.5q-202 0 -352 95.5t-227 261t-77 379.5zM242 707q0 -292 142 -462.5t372 -170.5q232 0 374 170t142 463q0 294 -142 463t-374 169 q-231 0 -372.5 -169.5t-141.5 -462.5zM569 1700h125l109 -193h-86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD3",
    horizAdvX: 1490,
    d: "M100 707q0 215 77 380.5t227 260t352 94.5q203 0 353 -94.5t227 -259.5t77 -381q0 -214 -77 -379.5t-227 -261t-353 -95.5q-202 0 -352 95.5t-227 261t-77 379.5zM242 707q0 -292 142 -462.5t372 -170.5q232 0 374 170t142 463q0 294 -142 463t-374 169 q-231 0 -372.5 -169.5t-141.5 -462.5zM705 1507l110 193h123l-147 -193h-86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD4",
    horizAdvX: 1490,
    d: "M100 707q0 215 77 380.5t227 260t352 94.5q203 0 353 -94.5t227 -259.5t77 -381q0 -214 -77 -379.5t-227 -261t-353 -95.5q-202 0 -352 95.5t-227 261t-77 379.5zM242 707q0 -292 142 -462.5t372 -170.5q232 0 374 170t142 463q0 294 -142 463t-374 169 q-231 0 -372.5 -169.5t-141.5 -462.5zM575 1507l136 193h92l137 -193h-104l-80 135l-80 -135h-101z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD5",
    horizAdvX: 1490,
    d: "M100 707q0 215 77 380.5t227 260t352 94.5q203 0 353 -94.5t227 -259.5t77 -381q0 -214 -77 -379.5t-227 -261t-353 -95.5q-202 0 -352 95.5t-227 261t-77 379.5zM242 707q0 -292 142 -462.5t372 -170.5q232 0 374 170t142 463q0 294 -142 463t-374 169 q-231 0 -372.5 -169.5t-141.5 -462.5zM553 1548q0 65 24 93t70 28q41 0 123 -27q67 -22 92 -22q33 0 33 41h63q0 -65 -24 -93t-70 -28q-40 0 -123 27q-67 22 -92 22q-33 0 -33 -41h-63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD6",
    horizAdvX: 1490,
    d: "M100 707q0 215 77 380.5t227 260t352 94.5q203 0 353 -94.5t227 -259.5t77 -381q0 -214 -77 -379.5t-227 -261t-353 -95.5q-202 0 -352 95.5t-227 261t-77 379.5zM242 707q0 -292 142 -462.5t372 -170.5q232 0 374 170t142 463q0 294 -142 463t-374 169 q-231 0 -372.5 -169.5t-141.5 -462.5zM565 1604q0 31 21.5 52t52.5 21t52.5 -21t21.5 -52t-21.5 -52.5t-52.5 -21.5t-52.5 21.5t-21.5 52.5zM799 1604q0 31 21 52t52 21t52.5 -21t21.5 -52t-21.5 -52.5t-52.5 -21.5t-52 21.5t-21 52.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD7",
    d: "M219 350l293 293l-293 293l64 63l292 -292l293 292l64 -63l-293 -293l293 -293l-64 -63l-293 293l-292 -293z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD8",
    horizAdvX: 1501,
    d: "M92 100l139 140q-127 194 -127 467q0 215 77.5 380.5t227.5 260t353 94.5q297 0 475 -197l131 131l64 -63l-140 -139q127 -191 127 -467q0 -214 -77 -379.5t-227 -261t-353 -95.5q-294 0 -475 197l-131 -131zM246 707q0 -219 82 -371l819 819q-142 184 -385 184 q-232 0 -374 -169t-142 -463zM377 258q142 -184 385 -184q231 0 373.5 170.5t142.5 462.5q0 218 -82 370z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD9",
    horizAdvX: 1333,
    d: "M190 506v907h127v-901q0 -76 5 -125q13 -141 106 -227t264 -86q170 0 263 86t106 227q6 59 6 125v901h127v-907q0 -58 -6 -131q-13 -181 -138.5 -292.5t-357.5 -111.5t-357.5 111t-139.5 293q-5 61 -5 131zM506 1700h125l108 -193h-86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xDA",
    horizAdvX: 1333,
    d: "M190 506v907h127v-901q0 -76 5 -125q13 -141 106 -227t264 -86q170 0 263 86t106 227q6 59 6 125v901h127v-907q0 -58 -6 -131q-13 -181 -138.5 -292.5t-357.5 -111.5t-357.5 111t-139.5 293q-5 61 -5 131zM641 1507l111 193h122l-147 -193h-86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xDB",
    horizAdvX: 1333,
    d: "M190 506v907h127v-901q0 -76 5 -125q13 -141 106 -227t264 -86q170 0 263 86t106 227q6 59 6 125v901h127v-907q0 -58 -6 -131q-13 -181 -138.5 -292.5t-357.5 -111.5t-357.5 111t-139.5 293q-5 61 -5 131zM512 1507l135 193h92l138 -193h-105l-80 135l-80 -135h-100z "
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xDC",
    horizAdvX: 1333,
    d: "M190 506v907h127v-901q0 -76 5 -125q13 -141 106 -227t264 -86q170 0 263 86t106 227q6 59 6 125v901h127v-907q0 -58 -6 -131q-13 -181 -138.5 -292.5t-357.5 -111.5t-357.5 111t-139.5 293q-5 61 -5 131zM502 1604q0 31 21 52t52 21t52.5 -21t21.5 -52t-21.5 -52.5 t-52.5 -21.5t-52 21.5t-21 52.5zM735 1604q0 31 21.5 52t52.5 21t52.5 -21t21.5 -52t-21.5 -52.5t-52.5 -21.5t-52.5 21.5t-21.5 52.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xDD",
    horizAdvX: 1163,
    d: "M43 1413h145l424 -725l414 725h145l-501 -848v-565h-127v563zM555 1507l111 193h122l-147 -193h-86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xDE",
    horizAdvX: 1298,
    d: "M203 0v1413h127v-203h270q112 0 191 -10q159 -20 255.5 -114t96.5 -259q0 -168 -97 -267t-255 -120q-63 -8 -191 -8h-270v-432h-127zM330 541h270q111 0 172 10q105 17 169.5 82.5t64.5 189.5q0 227 -234 269q-61 10 -172 10h-270v-561z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xDF",
    horizAdvX: 1187,
    d: "M150 0v991q0 57 4 131q12 203 136 312.5t312 109.5t304 -95t116 -255q0 -109 -66 -211q-86 -44 -127 -83.5t-41 -88.5q0 -54 29 -97.5t101 -103.5q98 -83 141 -156t43 -171q0 -134 -104.5 -212.5t-270.5 -78.5q-109 0 -209 20v107q116 -27 203 -27q116 0 178 53t62 146 q0 60 -30.5 114t-117.5 132q-97 86 -131.5 141.5t-34.5 132.5q0 74 46.5 130t146.5 106q41 65 41 145q0 117 -76.5 183.5t-208.5 66.5q-131 0 -218 -85t-97 -239q-5 -72 -5 -114v-1004h-126z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE0",
    horizAdvX: 1058,
    d: "M82 272q0 183 164 276t463 93h69v39q0 90 -4 133q-16 197 -242 197q-116 0 -188 -62.5t-84 -185.5h-133q10 159 121.5 254.5t283.5 95.5q343 0 369 -287q4 -47 4 -143v-379q0 -109 21 -303h-127l-19 197l-53 -115q-111 -111 -301 -111q-155 0 -249.5 78.5t-94.5 222.5z M221 283q0 -103 62.5 -157t181.5 -54q140 0 226.5 96.5t86.5 249.5v125q-117 8 -216 -3t-176.5 -41t-121 -85t-43.5 -131zM324 1413h125l124 -225h-88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE1",
    horizAdvX: 1058,
    d: "M82 272q0 183 164 276t463 93h69v39q0 90 -4 133q-16 197 -242 197q-116 0 -188 -62.5t-84 -185.5h-133q10 159 121.5 254.5t283.5 95.5q343 0 369 -287q4 -47 4 -143v-379q0 -109 21 -303h-127l-19 197l-53 -115q-111 -111 -301 -111q-155 0 -249.5 78.5t-94.5 222.5z M221 283q0 -103 62.5 -157t181.5 -54q140 0 226.5 96.5t86.5 249.5v125q-117 8 -216 -3t-176.5 -41t-121 -85t-43.5 -131zM481 1188l125 225h123l-162 -225h-86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE2",
    horizAdvX: 1058,
    d: "M82 272q0 183 164 276t463 93h69v39q0 90 -4 133q-16 197 -242 197q-116 0 -188 -62.5t-84 -185.5h-133q10 159 121.5 254.5t283.5 95.5q343 0 369 -287q4 -47 4 -143v-379q0 -109 21 -303h-127l-19 197l-53 -115q-111 -111 -301 -111q-155 0 -249.5 78.5t-94.5 222.5z M221 283q0 -103 62.5 -157t181.5 -54q140 0 226.5 96.5t86.5 249.5v125q-117 8 -216 -3t-176.5 -41t-121 -85t-43.5 -131zM354 1188l135 225h93l137 -225h-101l-83 153l-82 -153h-99z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE3",
    horizAdvX: 1058,
    d: "M82 272q0 183 164 276t463 93h69v39q0 90 -4 133q-16 197 -242 197q-116 0 -188 -62.5t-84 -185.5h-133q10 159 121.5 254.5t283.5 95.5q343 0 369 -287q4 -47 4 -143v-379q0 -109 21 -303h-127l-19 197l-53 -115q-111 -111 -301 -111q-155 0 -249.5 78.5t-94.5 222.5z M221 283q0 -103 62.5 -157t181.5 -54q140 0 226.5 96.5t86.5 249.5v125q-117 8 -216 -3t-176.5 -41t-121 -85t-43.5 -131zM332 1251q0 66 23.5 94.5t70.5 28.5q44 0 123 -26q70 -23 92 -23q33 0 33 41h63q0 -66 -23.5 -94.5t-70.5 -28.5q-41 0 -123 27q-73 24 -92 24 q-33 0 -33 -43h-63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE4",
    horizAdvX: 1058,
    d: "M82 272q0 183 164 276t463 93h69v39q0 90 -4 133q-16 197 -242 197q-116 0 -188 -62.5t-84 -185.5h-133q10 159 121.5 254.5t283.5 95.5q343 0 369 -287q4 -47 4 -143v-379q0 -109 21 -303h-127l-19 197l-53 -115q-111 -111 -301 -111q-155 0 -249.5 78.5t-94.5 222.5z M221 283q0 -103 62.5 -157t181.5 -54q140 0 226.5 96.5t86.5 249.5v125q-117 8 -216 -3t-176.5 -41t-121 -85t-43.5 -131zM336 1292q0 29 22.5 51.5t51.5 22.5q30 0 52.5 -22t22.5 -52q0 -31 -22 -53t-53 -22q-30 0 -52 22.5t-22 52.5zM584 1292q0 30 22 52t53 22 q29 0 51.5 -22.5t22.5 -51.5q0 -30 -22.5 -52.5t-51.5 -22.5q-31 0 -53 22t-22 53z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE5",
    horizAdvX: 1058,
    d: "M82 272q0 183 164 276t463 93h69v39q0 90 -4 133q-16 197 -242 197q-116 0 -188 -62.5t-84 -185.5h-133q10 159 121.5 254.5t283.5 95.5q343 0 369 -287q4 -47 4 -143v-379q0 -109 21 -303h-127l-19 197l-53 -115q-111 -111 -301 -111q-155 0 -249.5 78.5t-94.5 222.5z M221 283q0 -103 62.5 -157t181.5 -54q140 0 226.5 96.5t86.5 249.5v125q-117 8 -216 -3t-176.5 -41t-121 -85t-43.5 -131zM371 1317q0 69 46.5 112.5t117.5 43.5t117 -43.5t46 -112.5q0 -67 -46 -110.5t-117 -43.5t-117.5 43.5t-46.5 110.5zM453 1317q0 -41 22.5 -66.5 t59.5 -25.5t59 25.5t22 66.5q0 42 -22.5 68t-58.5 26q-37 0 -59.5 -26.5t-22.5 -67.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE6",
    horizAdvX: 1845,
    d: "M82 272q0 91 46.5 156.5t136 104t207.5 56t273 17.5h70v53q0 172 -66.5 261.5t-211.5 89.5q-120 0 -195.5 -63t-85.5 -185h-131q6 160 118 255t294 95q153 0 243 -57.5t127 -173.5q61 112 164.5 171.5t235.5 59.5q112 0 200.5 -42t144 -116.5t84.5 -171.5t29 -211 q0 -34 -2 -67h-821q10 -219 106.5 -325.5t243.5 -106.5q118 0 208 70.5t118 199.5h133q-37 -181 -165.5 -276t-299.5 -95q-142 0 -253 66.5t-165 206.5l-51 -111q-151 -162 -375 -162q-99 0 -179 32.5t-130.5 102t-50.5 166.5zM221 283q0 -101 67.5 -156t184.5 -55 q148 0 245 103t97 269v60q-131 6 -232 -1t-186 -30t-130.5 -71t-45.5 -119zM942 604h694q-10 203 -99.5 304.5t-233.5 101.5q-151 0 -249.5 -104.5t-111.5 -301.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE7",
    horizAdvX: 1075,
    d: "M61 541q0 131 40.5 240t109.5 180.5t160.5 111t193.5 39.5q185 0 304.5 -104.5t144.5 -278.5h-133q-28 138 -109 210.5t-211 72.5q-70 0 -133.5 -28.5t-114.5 -83.5t-81.5 -145.5t-30.5 -203.5q0 -121 29 -215t78.5 -150.5t111 -85t131.5 -28.5q122 0 207 69t114 197h132 q-35 -172 -153 -267t-290 -100l-35 -61q83 -9 127.5 -51t44.5 -115q0 -84 -66 -129t-169 -45q-61 0 -105 18v74q43 -22 109 -22q65 0 102 26.5t37 75.5q0 118 -198 104l67 129q-187 23 -300.5 168t-113.5 398z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE8",
    horizAdvX: 1103,
    d: "M61 541q0 170 66 301t180 200.5t256 69.5q147 0 253 -73.5t157 -194.5t51 -273q0 -34 -4 -67h-821q5 -115 35.5 -201t80 -135t108.5 -72.5t128 -23.5q118 0 208 70.5t118 199.5h133q-37 -181 -166 -276t-301 -95q-103 0 -189.5 36t-152.5 105.5t-103 179.5t-37 249z M199 604h696q-10 201 -101.5 303.5t-234.5 102.5q-142 0 -244.5 -106.5t-115.5 -299.5zM356 1413h125l125 -225h-88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE9",
    horizAdvX: 1103,
    d: "M61 541q0 170 66 301t180 200.5t256 69.5q147 0 253 -73.5t157 -194.5t51 -273q0 -34 -4 -67h-821q5 -115 35.5 -201t80 -135t108.5 -72.5t128 -23.5q118 0 208 70.5t118 199.5h133q-37 -181 -166 -276t-301 -95q-103 0 -189.5 36t-152.5 105.5t-103 179.5t-37 249z M199 604h696q-10 201 -101.5 303.5t-234.5 102.5q-142 0 -244.5 -106.5t-115.5 -299.5zM498 1188l125 225h122l-161 -225h-86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xEA",
    horizAdvX: 1103,
    d: "M61 541q0 170 66 301t180 200.5t256 69.5q147 0 253 -73.5t157 -194.5t51 -273q0 -34 -4 -67h-821q5 -115 35.5 -201t80 -135t108.5 -72.5t128 -23.5q118 0 208 70.5t118 199.5h133q-37 -181 -166 -276t-301 -95q-103 0 -189.5 36t-152.5 105.5t-103 179.5t-37 249z M199 604h696q-10 201 -101.5 303.5t-234.5 102.5q-142 0 -244.5 -106.5t-115.5 -299.5zM371 1188l135 225h92l137 -225h-100l-84 153l-82 -153h-98z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xEB",
    horizAdvX: 1103,
    d: "M61 541q0 170 66 301t180 200.5t256 69.5q147 0 253 -73.5t157 -194.5t51 -273q0 -34 -4 -67h-821q5 -115 35.5 -201t80 -135t108.5 -72.5t128 -23.5q118 0 208 70.5t118 199.5h133q-37 -181 -166 -276t-301 -95q-103 0 -189.5 36t-152.5 105.5t-103 179.5t-37 249z M199 604h696q-10 201 -101.5 303.5t-234.5 102.5q-142 0 -244.5 -106.5t-115.5 -299.5zM352 1292q0 29 22.5 51.5t51.5 22.5q31 0 53.5 -22.5t22.5 -51.5q0 -31 -22.5 -53t-53.5 -22q-30 0 -52 22.5t-22 52.5zM600 1292q0 29 22.5 51.5t53.5 22.5q29 0 51.5 -22.5 t22.5 -51.5q0 -30 -22 -52.5t-52 -22.5q-31 0 -53.5 22t-22.5 53z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xEC",
    horizAdvX: 430,
    d: "M2 1413h125l125 -225h-88zM150 0v1083h126v-1083h-126z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xED",
    horizAdvX: 430,
    d: "M150 0v1083h126v-1083h-126zM160 1188l125 225h123l-162 -225h-86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xEE",
    horizAdvX: 430,
    d: "M33 1188l135 225h92l137 -225h-100l-84 153l-82 -153h-98zM150 0v1083h126v-1083h-126z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xEF",
    horizAdvX: 430,
    d: "M14 1292q0 29 22.5 51.5t51.5 22.5q31 0 53.5 -22.5t22.5 -51.5q0 -31 -22.5 -53t-53.5 -22q-30 0 -52 22.5t-22 52.5zM150 0v1083h126v-1083h-126zM262 1292q0 29 22.5 51.5t53.5 22.5q29 0 51.5 -22.5t22.5 -51.5q0 -30 -22 -52.5t-52 -22.5q-31 0 -53.5 22t-22.5 53z "
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF0",
    d: "M61 526q0 174 65 309t176 207t249 72q142 0 252 -72l94 -127q-21 240 -152 375l-305 -125l-32 82l262 109q-85 56 -183 84l80 86q124 -45 221 -123l142 59l33 -82l-107 -43q101 -114 149 -286.5t48 -421.5q0 -171 -39.5 -300.5t-110 -206t-160 -114t-198.5 -37.5 q-116 0 -209 42t-152.5 117t-91 175.5t-31.5 220.5zM201 541q0 -220 95 -344.5t259 -124.5q163 0 261.5 125.5t98.5 357.5v53q0 99 -29 178t-79 128t-112 74.5t-132 25.5q-158 0 -260 -128.5t-102 -344.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF1",
    horizAdvX: 1165,
    d: "M150 0v1083h126v-209l58 117q121 121 305 121q169 0 267.5 -86t113.5 -238q4 -55 4 -182v-606h-127v592q0 109 -4 164q-11 117 -79.5 184.5t-199.5 67.5q-147 0 -242.5 -115.5t-95.5 -353.5v-539h-126zM389 1251q0 66 23.5 94.5t70.5 28.5q44 0 123 -26q70 -23 92 -23 q33 0 33 41h64q0 -66 -24 -94.5t-71 -28.5q-40 0 -122 27q-73 24 -93 24q-32 0 -32 -43h-64z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF2",
    horizAdvX: 1175,
    d: "M61 541q0 162 59 289.5t180 204.5t288 77t288 -77t179.5 -204.5t58.5 -289.5q0 -120 -34.5 -223t-99 -180.5t-165.5 -122t-227 -44.5q-167 0 -288 77t-180 204.5t-59 288.5zM201 541q0 -217 107.5 -343t279.5 -126t279.5 126t107.5 343t-107.5 343t-279.5 126 t-279.5 -126t-107.5 -343zM393 1413h125l125 -225h-88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF3",
    horizAdvX: 1175,
    d: "M61 541q0 162 59 289.5t180 204.5t288 77t288 -77t179.5 -204.5t58.5 -289.5q0 -120 -34.5 -223t-99 -180.5t-165.5 -122t-227 -44.5q-167 0 -288 77t-180 204.5t-59 288.5zM201 541q0 -217 107.5 -343t279.5 -126t279.5 126t107.5 343t-107.5 343t-279.5 126 t-279.5 -126t-107.5 -343zM535 1188l124 225h123l-161 -225h-86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF4",
    horizAdvX: 1175,
    d: "M61 541q0 162 59 289.5t180 204.5t288 77t288 -77t179.5 -204.5t58.5 -289.5q0 -120 -34.5 -223t-99 -180.5t-165.5 -122t-227 -44.5q-167 0 -288 77t-180 204.5t-59 288.5zM201 541q0 -217 107.5 -343t279.5 -126t279.5 126t107.5 343t-107.5 343t-279.5 126 t-279.5 -126t-107.5 -343zM408 1188l135 225h92l137 -225h-100l-84 153l-82 -153h-98z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF5",
    horizAdvX: 1175,
    d: "M61 541q0 162 59 289.5t180 204.5t288 77t288 -77t179.5 -204.5t58.5 -289.5q0 -120 -34.5 -223t-99 -180.5t-165.5 -122t-227 -44.5q-167 0 -288 77t-180 204.5t-59 288.5zM201 541q0 -217 107.5 -343t279.5 -126t279.5 126t107.5 343t-107.5 343t-279.5 126 t-279.5 -126t-107.5 -343zM385 1251q0 66 23.5 94.5t70.5 28.5q44 0 123 -26q70 -23 92 -23q33 0 33 41h64q0 -66 -24 -94.5t-71 -28.5q-40 0 -123 27q-74 24 -92 24q-32 0 -32 -43h-64z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF6",
    horizAdvX: 1175,
    d: "M61 541q0 162 59 289.5t180 204.5t288 77t288 -77t179.5 -204.5t58.5 -289.5q0 -120 -34.5 -223t-99 -180.5t-165.5 -122t-227 -44.5q-167 0 -288 77t-180 204.5t-59 288.5zM201 541q0 -217 107.5 -343t279.5 -126t279.5 126t107.5 343t-107.5 343t-279.5 126 t-279.5 -126t-107.5 -343zM389 1292q0 29 22.5 51.5t51.5 22.5q31 0 53.5 -22.5t22.5 -51.5q0 -31 -22.5 -53t-53.5 -22q-29 0 -51.5 22.5t-22.5 52.5zM637 1292q0 29 22.5 51.5t53.5 22.5q29 0 51 -22.5t22 -51.5q0 -31 -22 -53t-51 -22q-31 0 -53.5 22t-22.5 53z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF7",
    d: "M152 608v88h845v-88h-845zM485 326q0 40 26.5 66t66.5 26t66 -26t26 -66t-26 -66.5t-66 -26.5t-66.5 26.5t-26.5 66.5zM485 973q0 40 26.5 66t66.5 26t66 -26t26 -66q0 -39 -26.5 -65.5t-65.5 -26.5q-40 0 -66.5 26.5t-26.5 65.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF8",
    horizAdvX: 1249,
    d: "M53 33l140 139q-107 150 -107 369q0 162 58.5 289.5t179.5 204.5t288 77q233 0 375 -145l146 145l63 -63l-154 -154q97 -148 97 -354q0 -161 -59 -288.5t-180 -204.5t-288 -77q-224 0 -360 133l-135 -135zM223 541q0 -159 62 -277l612 613q-108 133 -285 133 q-172 0 -280.5 -126t-108.5 -343zM338 190q106 -118 274 -118q171 0 279 126t108 343q0 152 -53 258z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF9",
    horizAdvX: 1161,
    d: "M133 451v632h127v-604q0 -89 8 -162q12 -111 84.5 -177t194.5 -66q70 0 128.5 26.5t105.5 81t73.5 147.5t26.5 216v538h127v-1083h-127v209l-60 -121q-120 -117 -303 -117q-161 0 -259.5 81.5t-117.5 215.5q-8 73 -8 183zM362 1413h125l125 -225h-88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xFA",
    horizAdvX: 1161,
    d: "M133 451v632h127v-604q0 -89 8 -162q12 -111 84.5 -177t194.5 -66q70 0 128.5 26.5t105.5 81t73.5 147.5t26.5 216v538h127v-1083h-127v209l-60 -121q-120 -117 -303 -117q-161 0 -259.5 81.5t-117.5 215.5q-8 73 -8 183zM516 1188l125 225h123l-162 -225h-86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xFB",
    horizAdvX: 1161,
    d: "M133 451v632h127v-604q0 -89 8 -162q12 -111 84.5 -177t194.5 -66q70 0 128.5 26.5t105.5 81t73.5 147.5t26.5 216v538h127v-1083h-127v209l-60 -121q-120 -117 -303 -117q-161 0 -259.5 81.5t-117.5 215.5q-8 73 -8 183zM389 1188l135 225h92l138 -225h-101l-84 153 l-82 -153h-98z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xFC",
    horizAdvX: 1161,
    d: "M133 451v632h127v-604q0 -89 8 -162q12 -111 84.5 -177t194.5 -66q70 0 128.5 26.5t105.5 81t73.5 147.5t26.5 216v538h127v-1083h-127v209l-60 -121q-120 -117 -303 -117q-161 0 -259.5 81.5t-117.5 215.5q-8 73 -8 183zM371 1292q0 29 22 51.5t51 22.5q31 0 53.5 -22.5 t22.5 -51.5q0 -31 -22.5 -53t-53.5 -22q-29 0 -51 22t-22 53zM618 1292q0 29 22.5 51.5t53.5 22.5q29 0 51.5 -22.5t22.5 -51.5q0 -30 -22 -52.5t-52 -22.5q-31 0 -53.5 22t-22.5 53z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xFD",
    horizAdvX: 1007,
    d: "M12 1083h144l350 -989l348 989h139l-434 -1140q-81 -209 -165.5 -291t-203.5 -82q-59 0 -84 6v105q34 -5 70 -5q77 0 134.5 50.5t107.5 175.5l22 57zM453 1188l125 225h122l-161 -225h-86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xFE",
    horizAdvX: 1200,
    d: "M150 -401v1906h126v-622l72 118q114 111 307 111q223 0 353.5 -155.5t130.5 -401.5q0 -143 -42 -256.5t-114 -184t-163.5 -107t-196.5 -36.5q-81 0 -155 25t-124 72l-68 116v-585h-126zM276 485q0 -111 31 -194t83 -129t110.5 -68t122.5 -22q166 0 271 125.5t105 341.5 q0 133 -40 238t-123.5 169t-198.5 64q-76 0 -138.5 -24t-114 -74t-80 -138t-28.5 -207v-82z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xFF",
    horizAdvX: 1007,
    d: "M12 1083h144l350 -989l348 989h139l-434 -1140q-81 -209 -165.5 -291t-203.5 -82q-59 0 -84 6v105q34 -5 70 -5q77 0 134.5 50.5t107.5 175.5l22 57zM307 1292q0 29 22.5 51.5t51.5 22.5q31 0 53.5 -22.5t22.5 -51.5q0 -31 -22.5 -53t-53.5 -22q-29 0 -51.5 22.5 t-22.5 52.5zM555 1292q0 29 22.5 51.5t53.5 22.5q29 0 51.5 -22.5t22.5 -51.5q0 -30 -22.5 -52.5t-51.5 -22.5q-31 0 -53.5 22t-22.5 53z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u0152",
    horizAdvX: 2248,
    d: "M100 707q0 156 45 290.5t126.5 233t203 155t268.5 56.5q164 0 270.5 -49t200.5 -166l58 -154v340h897v-104h-770v-549h717v-107h-717v-549h790v-104h-917v340l-58 -154q-87 -113 -202.5 -164t-268.5 -51q-195 0 -342.5 98t-224 264t-76.5 374zM242 707q0 -287 142.5 -460 t371.5 -173q234 0 375 172.5t141 460.5q0 290 -141 461t-375 171q-230 0 -372 -171.5t-142 -460.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u0153",
    horizAdvX: 2017,
    d: "M61 541q0 162 59 289.5t180 204.5t288 77q166 0 283.5 -77.5t175.5 -227.5q58 150 173 227.5t259 77.5q111 0 199 -42.5t144 -116.5t85.5 -171.5t29.5 -210.5q0 -34 -2 -67h-819q4 -112 34.5 -197t79.5 -135.5t107.5 -75t126.5 -24.5q118 0 208 70.5t118 199.5h133 q-37 -181 -165.5 -276t-299.5 -95q-142 0 -252 74.5t-168 226.5q-59 -148 -173 -224.5t-277 -76.5q-167 0 -288 77t-180 204.5t-59 288.5zM201 541q0 -217 107.5 -343t279.5 -126t279.5 126t107.5 343t-107.5 343t-279.5 126t-279.5 -126t-107.5 -343zM1116 604h692 q-10 202 -100.5 304t-232.5 102q-144 0 -246 -105.5t-113 -300.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u0178",
    horizAdvX: 1163,
    d: "M43 1413h145l424 -725l414 725h145l-501 -848v-565h-127v563zM416 1604q0 31 21 52t52 21t52.5 -21t21.5 -52t-21.5 -52.5t-52.5 -21.5t-52 21.5t-21 52.5zM649 1604q0 31 21.5 52t52.5 21t52.5 -21t21.5 -52t-21.5 -52.5t-52.5 -21.5t-52.5 21.5t-21.5 52.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u02C6",
    horizAdvX: 614,
    d: "M127 1188l135 225h92l138 -225h-101l-84 153l-82 -153h-98z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u02DC",
    horizAdvX: 614,
    d: "M104 1251q0 66 24 94.5t71 28.5q44 0 123 -26q70 -23 92 -23q32 0 32 41h64q0 -66 -23.5 -94.5t-70.5 -28.5q-40 0 -123 27q-73 24 -92 24q-33 0 -33 -43h-64z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2000",
    horizAdvX: 883
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2001",
    horizAdvX: 1767
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2002",
    horizAdvX: 883
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2003",
    horizAdvX: 1767
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2004",
    horizAdvX: 589
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2005",
    horizAdvX: 441
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2006",
    horizAdvX: 294
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2007",
    horizAdvX: 294
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2008",
    horizAdvX: 220
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2009",
    horizAdvX: 353
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u200A",
    horizAdvX: 98
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2010",
    horizAdvX: 561,
    d: "M66 535v88h430v-88h-430z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2011",
    horizAdvX: 561,
    d: "M66 535v88h430v-88h-430z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2012",
    horizAdvX: 561,
    d: "M66 535v88h430v-88h-430z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2013",
    horizAdvX: 1024,
    d: "M143 553v88h738v-88h-738z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2014",
    horizAdvX: 2048,
    d: "M143 553v88h1762v-88h-1762z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2018",
    horizAdvX: 403,
    d: "M80 997v17l178 491h113l-154 -508h-137z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2019",
    horizAdvX: 403,
    d: "M33 997l153 508h138v-16l-177 -492h-114z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u201A",
    horizAdvX: 397,
    d: "M-41 -244l135 391h137v-18l-153 -373h-119z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u201C",
    horizAdvX: 690,
    d: "M80 997v17l176 491h115l-154 -508h-137zM367 997v17l176 491h114l-153 -508h-137z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u201D",
    horizAdvX: 690,
    d: "M33 997l153 508h138v-16l-177 -492h-114zM319 997l154 508h137v-16l-176 -492h-115z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u201E",
    horizAdvX: 667,
    d: "M-41 -244l135 391h137v-18l-153 -373h-119zM229 -244l136 391h137l2 -18l-156 -373h-119z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2022",
    horizAdvX: 600,
    d: "M133 625q0 72 47.5 120t118.5 48q72 0 120 -48t48 -120t-48 -120t-120 -48q-71 0 -118.5 48t-47.5 120z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2026",
    horizAdvX: 1062,
    d: "M78 70q0 41 27.5 68.5t70.5 27.5q41 0 68.5 -27.5t27.5 -68.5q0 -43 -27.5 -71t-68.5 -28q-43 0 -70.5 28t-27.5 71zM412 70q0 41 27.5 68.5t68.5 27.5t69.5 -27.5t28.5 -68.5q0 -42 -28 -70.5t-70 -28.5q-41 0 -68.5 28t-27.5 71zM743 70q0 41 28 68.5t71 27.5 q41 0 68.5 -27.5t27.5 -68.5q0 -43 -27.5 -71t-68.5 -28q-43 0 -71 28t-28 71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u202F",
    horizAdvX: 353
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2039",
    horizAdvX: 788,
    d: "M260 508l281 340h116l-280 -340l280 -340h-116z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u203A",
    horizAdvX: 788,
    d: "M133 168l281 340l-281 340h115l280 -340l-280 -340h-115z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u205F",
    horizAdvX: 441
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u20AC",
    d: "M35 549l20 86h121l-2 65q0 49 2 74h-98l20 86h84q23 194 104 326.5t202.5 194t277.5 61.5q218 0 334 -125l-66 -86q-102 108 -272 108q-83 0 -153 -26t-130 -81t-100 -149.5t-55 -222.5h663l-22 -86h-648l-2 -65q0 -49 2 -74h615l-19 -86h-589q26 -246 135 -360.5 t301 -114.5q166 0 295 82v-109q-133 -76 -305 -76q-254 0 -398 136.5t-172 441.5h-145z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2122",
    horizAdvX: 1087,
    d: "M45 1284v68h399v-68h-159v-350h-82v350h-158zM496 934v416h118l111 -340l109 340h116v-416h-80l4 323l-110 -317h-84l-109 315l2 -321h-77z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u25FC",
    horizAdvX: 1085,
    d: "M0 0v1085h1085v-1085h-1085z"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "U",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "U",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "U",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "U",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "U",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "U",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "U",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ydieresis",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    k: 166
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ydieresis",
    g2: "c,d,e,g,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,oe",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ydieresis",
    g2: "u,ugrave,uacute,ucircumflex,udieresis",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ydieresis",
    g2: "z",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ydieresis",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae",
    k: 96
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w",
    g2: "period,ellipsis",
    k: 117
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "c,d,e,g,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,oe",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,OE",
    k: -29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "J",
    k: 137
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla",
    g2: "T",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,uniFB02",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae",
    k: -37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,uniFB02",
    g2: "v",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G",
    g2: "T",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G",
    g2: "Y,Yacute,Ydieresis",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,oe",
    g2: "x",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,oe",
    g2: "y,yacute,ydieresis",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "c,d,e,g,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,oe",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae",
    k: -18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,OE",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t",
    g2: "c,d,e,g,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,oe",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash",
    g2: "T",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash",
    g2: "Y,Yacute,Ydieresis",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash",
    g2: "V",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash",
    g2: "W",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash",
    g2: "Z",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "c,d,e,g,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,oe",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "period,ellipsis",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "c,d,e,g,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,oe",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,OE",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,OE",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L",
    g2: "T",
    k: 287
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L",
    g2: "Y,Yacute,Ydieresis",
    k: 313
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L",
    g2: "V",
    k: 242
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L",
    g2: "W",
    k: 168
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "c,d,e,g,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,oe",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,OE",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    g2: "T",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    g2: "v",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    g2: "Y,Yacute,Ydieresis",
    k: 162
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    g2: "y,yacute,ydieresis",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    g2: "V",
    k: 139
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    g2: "W",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    g2: "t",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    g2: "quoteright,quotedblright",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    g2: "S",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    g2: "w",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis",
    g2: "c,d,e,g,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,oe",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "c,d,e,g,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,oe",
    k: 135
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "u,ugrave,uacute,ucircumflex,udieresis",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae",
    k: 106
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,OE",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "m,n,p,r,ntilde",
    k: 121
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "b,h,k,thorn",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r",
    g2: "c,d,e,g,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,oe",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k",
    g2: "c,d,e,g,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,oe",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z",
    g2: "c,d,e,g,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,oe",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "J",
    k: 152
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,o,p,ograve,oacute,ocircumflex,otilde,odieresis,oslash,thorn",
    g2: "x",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    k: 41
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAileronLightWebfont);
export default __webpack_public_path__ + "static/media/aileron-light-webfont.3d1a0d811ed62b91a5d3ea6c69cafa59.svg";
export { ForwardRef as ReactComponent };